const lightDemoKey = 'demoLightOrg';
const demoOrganizations = [
  '60b97525-886b-4390-8758-08b7ea2bcc5b',
  'ac861638-1ee8-11e9-94b8-cb309041931e',
];

export function isDemoOrganization(id: string): boolean {
  return demoOrganizations.includes(id);
}

export function setLightOrganizationDemo(value: boolean): void {
  window.localStorage.setItem(lightDemoKey, value ? '1' : '0');
}

export function isLightOrganizationDemo(): boolean {
  const value = window.localStorage.getItem(lightDemoKey);
  if (value === '1') {
    return true;
  }
  return false;
}
